import { CSSObject } from "@emotion/react";

export const containerStyles: CSSObject = {
  display: "flex",
  flexDirection: "row",
  maxWidth: "100%",
  height: "100%",
  padding: "24px 16px",
  gap: "16px",
};

export const leftPanelStyles: CSSObject = {
  height: "100%",
};
